import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_ReleaseOfInformation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_ReleaseOfInformation' className='file-pdf-document'>
            <div className='file-template'>




                <p className='w-750'> <center> Re: Release of Information /Care of Coordination </center> </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Client</span>
                            <input type="text" name="txtReferralClient" id="txtReferralClient" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB:</span>
                            <input type="date" name="txtAssessmentDob" id="txtAssessmentDob" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Parent/Guardian</span>
                            <input type="text" name="txtParentGuardian" id="txtParentGuardian" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Dear <input type="text" name="txtDear" id="txtDear" placeholder="(provider)" className='add-only' />,
                </p>
                <p className='w-750'>
                    <input type="text" name="txtDear1" id="txtDear1" className='add-only w-250 custom-add-only' /> has identified you as their provider. In my work with the client, we have discussed the importance of coordinating care across health care professionals. In response to this discussion, the client above has signed an authorization form allowing us to exchange pertinent information with you regarding their care. Please note that Restore Outreach Center (ROC) is behavior health provider and we are currently providing community-based mental health services to the client. If you would like any further contact regarding this case, or if you have further information that you think might assist us in better meeting this individual's clinical needs, please feel free to contact me directly. I look forward to our working together on an integrated approach for an optimal treatment outcome. Please save this correspondence and the attached consent in your records.
                </p>
                <p className='w-750'>
                    Respectfully,
                    <br />
                    Clinical Supervisor on Call
                    Restore Outreach Center, LLC
                    216-304-7848 (Phone)
                </p>



            </div>
        </form>

    )
}